var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "祺信详情",
        width: "80%",
        footer: null,
        destroyOnClose: ""
      },
      on: { cancel: _vm.close },
      model: {
        value: _vm.modalShow,
        callback: function($$v) {
          _vm.modalShow = $$v
        },
        expression: "modalShow"
      }
    },
    [
      _c("div", { staticClass: "gold-page" }, [
        _c("div", { staticClass: "spaceBetween" }, [
          _c("div", [
            _c("div", { staticClass: "gold-line" }, [
              _vm._v(
                "开立日：" +
                  _vm._s(
                    _vm._f("dateFormat")(_vm.pageData.estbDay, "YYYY-mm-dd")
                  )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gold-line" }, [
              _vm._v(
                "到期日：" +
                  _vm._s(_vm._f("dateFormat")(_vm.pageData.exDay, "YYYY-mm-dd"))
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-weight": "bold",
                "font-size": "18px",
                position: "relative",
                left: "20px"
              }
            },
            [_vm._v("祺信")]
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "gold-line" }, [
              _vm._v(
                "状态：\n                    " +
                  _vm._s(
                    _vm._f("GbGldStCdTrans")(
                      _vm.pageData.isPledged == 1
                        ? _vm.pageData.pledgeStatus | _vm.pledgeStatus
                        : _vm.pageData.gldStCd
                    )
                  ) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gold-line" }, [
              _vm._v("编号：" + _vm._s(_vm.pageData.gldId))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "gold-detail-table" }, [
          _vm.pageData.isPledged != 1
            ? _c("tr", [
                _c("td", [_vm._v("流转方")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pageData.pyptNm))]),
                _vm._v(" "),
                _c("td", [_vm._v("统一社会信用代码")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pageData.pyptOrgCode))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pageData.isPledged != 1
            ? _c("tr", [
                _c("td", [_vm._v("接收方")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.pageData.rcPtyNm ||
                        _vm.pageData.tenantNm ||
                        _vm.pageData.tenantName
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v("统一社会信用代码")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.pageData.rcPtyOrgCode || _vm.pageData.tenantOrgCode
                    )
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("开立方")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.pageData.estbNm))]),
            _vm._v(" "),
            _c("td", [_vm._v("统一社会信用代码")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.pageData.estbOrgCode))])
          ]),
          _vm._v(" "),
          _vm.pageData.grtStCd == 2
            ? _c("tr", [
                _c("td", [_vm._v("保证人")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pageData.guarantorName))]),
                _vm._v(" "),
                _c("td", [_vm._v("统一社会信用代码")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pageData.guarantorOrgCode))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pageData.isPledged == 1
            ? _c("tr", [
                _c("td", [_vm._v("出质人")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pageData.pledgorNm))]),
                _vm._v(" "),
                _c("td", [_vm._v("统一社会信用代码")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pageData.pledgorOrgCode))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pageData.isPledged == 1
            ? _c("tr", [
                _c("td", [_vm._v("质权人")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pageData.pledgeeName))]),
                _vm._v(" "),
                _c("td", [_vm._v("统一社会信用代码")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pageData.pledgeeOrgCode))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("tr", [
            _c(
              "td",
              { staticStyle: { height: "50px" }, attrs: { colspan: "4" } },
              [
                _c("span", [_vm._v("祺信金额")]),
                _vm._v(" "),
                _c("span", { staticStyle: { "margin-left": "60px" } }, [
                  _vm._v("(大写)" + _vm._s(_vm.pageData.bigGldAmt))
                ]),
                _vm._v(" "),
                _c("span", { staticStyle: { "margin-left": "160px" } }, [
                  _vm._v(
                    "(小写)¥" + _vm._s(_vm._f("splitK")(_vm.pageData.gldAmt))
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { attrs: { colspan: "4" } }, [
              _c("span", [
                _vm._v(
                  "\n                    开立方声明：我司已对本祺信出具《付款承诺函（" +
                    _vm._s(_vm.pageData.firstGldId) +
                    "\n                        ）》，到期无条件依据持票方明细付款。    承诺日期：" +
                    _vm._s(
                      _vm._f("dateFormat")(_vm.pageData.signTime, "YYYY-mm-dd")
                    ) +
                    "\n                    "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          +_vm.pageData.isPledged !== 1
            ? _c("tr", [
                _c(
                  "td",
                  {
                    staticClass: "detail-table__remarks",
                    attrs: { colspan: "4" }
                  },
                  [
                    +_vm.pageData.canBeModified === 0
                      ? _c("span", [
                          _vm._v("备注：本祺信可以全部或部分流转支付"),
                          _vm.pageData.firstGldId !== _vm.pageData.gldId
                            ? _c("span", [_vm._v("，也可以随时申请融资")])
                            : _vm._e(),
                          _vm._v("。")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    +_vm.pageData.canBeModified === 1 ||
                    +_vm.pageData.canBeModified === 3
                      ? _c("span", [
                          _vm._v("备注：本祺信可以全部或部分流转支付"),
                          _vm.pageData.firstGldId !== _vm.pageData.gldId
                            ? _c("span", [_vm._v("，也可以随时申请融资")])
                            : _vm._e(),
                          _vm._v("。"),
                          _c("b", [
                            _vm._v(
                              "开立方可对本祺信的到期日期进行变更，变更后的祺信到期日期将早于" +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    _vm.pageData.exDay,
                                    "YYYY-mm-dd"
                                  )
                                ) +
                                "。"
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    +_vm.pageData.canBeModified === 2
                      ? _c("span", [
                          _vm._v("备注：本祺信可以全部或部分流转支付"),
                          _vm.pageData.firstGldId !== _vm.pageData.gldId
                            ? _c("span", [_vm._v("，也可以随时申请融资")])
                            : _vm._e(),
                          _vm._v("。"),
                          _c("b", [
                            _vm._v(
                              "开立方已于" +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    _vm.pageData.modifiedDay,
                                    "YYYY-mm-dd"
                                  )
                                ) +
                                "，将到期日期由" +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    _vm.pageData.beforeModified,
                                    "YYYY-mm-dd"
                                  )
                                ) +
                                "变更为" +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    _vm.pageData.afterModified,
                                    "YYYY-mm-dd"
                                  )
                                ) +
                                "。"
                            )
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          +_vm.pageData.isPledged === 1
            ? _c("tr", [
                _c(
                  "td",
                  {
                    staticClass: "detail-table__remarks",
                    attrs: { colspan: "4" }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "备注：本祺信已质押,清分款项需先用于偿还出质人的债务."
                      )
                    ])
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "spaceBetween",
            staticStyle: { "margin-top": "10px" }
          },
          [
            !_vm.isFnc
              ? [
                  _c("div", [
                    _c("div", { staticClass: "gold-line" }, [
                      _vm._v("流转方财务记账建议：")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "gold-line" }, [
                      _vm._v(
                        "借：应付账款-" +
                          _vm._s(
                            _vm.pageData.rcPtyNm ||
                              _vm.pageData.tenantNm ||
                              _vm.pageData.tenantName
                          ) +
                          " "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "gold-line" }, [
                      _vm._v(
                        "贷：应付账款-祺信(" +
                          _vm._s(_vm.pageData.gldId) +
                          "） "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "gold-line" }, [
                      _vm._v("接收方财务记账建议：")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "gold-line" }, [
                      _vm._v(
                        "借：应收账款-祺信(" +
                          _vm._s(_vm.pageData.gldId) +
                          "） "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "gold-line" }, [
                      _vm._v(
                        "贷：应收账款-" + _vm._s(_vm.pageData.pyptNm) + " "
                      )
                    ])
                  ])
                ]
              : [
                  _c("div", [
                    _c("div", { staticClass: "gold-line" }, [
                      _vm._v("流转方财务记账建议：")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "gold-line" }, [
                      _vm._v("借：银行存款")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "gold-line",
                        staticStyle: { "margin-left": "28px" }
                      },
                      [_vm._v("财务费用")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "gold-line" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "gold-line" }, [
                      _vm._v(
                        "贷：应收账款-祺信(" +
                          _vm._s(_vm.pageData.gldId) +
                          "） "
                      )
                    ])
                  ])
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.gldId
        ? _c("goldDetailOriginInfo", {
            attrs: { goldIdParam: _vm.gldId },
            on: {
              "update:goldIdParam": function($event) {
                _vm.gldId = $event
              },
              "update:gold-id-param": function($event) {
                _vm.gldId = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cbce588c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbce588c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gold-page/gold-detail-dialog.vue
// module id = nKP5
// module chunks = 1